import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Experience } from "@/components/Experience";
import { Services } from "@/components/Services";
import { TechNetwork } from "@/components/TechNetwork";
import { WhatWeBuild } from "@/components/WhatWeBuild";
import { AISection } from "@/components/AISection";
import { CloudDevOps } from "@/components/CloudDevOps";
import { HowWeWork } from "@/components/HowWeWork";
import { WhyFarmint } from "@/components/WhyFarmint";
import { EngagementModels } from "@/components/EngagementModels";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import ServiceDetail from "@/pages/ServiceDetail";

function Landing() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72 });
      }, 350);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [hash]);
  return (
    <main>
      <Hero />
      <Experience />
      <Services />
      <TechNetwork />
      <WhatWeBuild />
      <AISection />
      <CloudDevOps />
      <HowWeWork />
      <WhyFarmint />
      <EngagementModels />
      <ContactSection />
    </main>
  );
}

function App() {
  const [theme, setTheme] = useState(() =>
    typeof window !== "undefined" && document.documentElement.classList.contains("light") ? "light" : "dark"
  );

  useEffect(() => {
    document.documentElement.classList.toggle("light", theme === "light");
    try {
      localStorage.setItem("farmint-theme", theme);
    } catch (e) {}
  }, [theme]);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 1 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -72 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-background text-foreground" data-testid="app-root">
      <BrowserRouter>
        <Navbar theme={theme} onToggleTheme={() => setTheme((t) => (t === "dark" ? "light" : "dark"))} />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
        </Routes>
        <Footer />
        <Toaster theme={theme} position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
